/**
 * Failure reason copy for Explore Unknown run endings.
 * Welcome leaderboard uses third person; AfterBattle loss screen uses second person.
 */

/**
 * @param {{ bossIntroTranslationKey?: string | null, endReason?: string, opponentFactionName?: string | null }} statistics
 * @param {(key: string, opts?: object) => string} t
 * @param {(factionName: string) => string} getTranslatedFactionName
 * @param {{ secondPerson?: boolean }} [options]
 * @returns {string}
 */
export function exploreUnknownRunFailureLabel(
  statistics,
  t,
  getTranslatedFactionName,
  { secondPerson = false } = {}
) {
  if (!statistics || typeof statistics !== 'object') {
    throw new Error('exploreUnknownRunFailureLabel: statistics is required');
  }
  const prefix = secondPerson
    ? 'afterBattle.exploreUnknownRunStats'
    : 'welcome.exploreUnknownLeaderboard';

  if (statistics.bossIntroTranslationKey) {
    const bossName = t(statistics.bossIntroTranslationKey);
    return t(`${prefix}.failureLoss`, {
      faction: bossName.toUpperCase(),
    });
  }
  if (statistics.endReason === 'complete') {
    return t(`${prefix}.homecomingSuccess`);
  }
  if (statistics.endReason === 'darkness') {
    return t(`${prefix}.failureDarkness`);
  }
  if (statistics.endReason === 'loss') {
    if (!statistics.opponentFactionName) {
      throw new Error('exploreUnknownRunFailureLabel: opponentFactionName is required for loss run');
    }
    return t(`${prefix}.failureLoss`, {
      faction: getTranslatedFactionName(statistics.opponentFactionName),
    });
  }
  return t(`${prefix}.failureUnknown`);
}
